export const SG_ALL_IN_ONE_STORAGE_TOKEN_KEY = 'shipperguide-all-in-one-user-token'
